import { JSX } from 'react';
import classNames from 'classnames';
import { RippleButton } from '@bg-components/RippleButton';
import { DirectionalIcon, IconDirection } from '@bg-components/Icon';
import classes from './ArrowButton.module.scss';

interface IProps {
    direction: IconDirection;
    onClick(direction: IconDirection): void;
    disabled: boolean;
    inLobby?: boolean;
}
export const ArrowButton = (props: IProps): JSX.Element => {
    return (
        <RippleButton
            dataQa={`button-arrow-${props.direction}`}
            className={classNames(classes.container, {
                [classes.disabled]: props.disabled,
                [classes.lobby]: props.inLobby,
            })}
            onClick={() => {
                props.onClick(props.direction);
            }}
            disabled={props.disabled}
        >
            <DirectionalIcon className={classes.icon} direction={props.direction} />
        </RippleButton>
    );
};
